import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createBlock as _createBlock, vModelText as _vModelText, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "row",
  id: "scenario-page"
}
const _hoisted_3 = { class: "col-12 card" }
const _hoisted_4 = { class: "row mx-2 my-5" }
const _hoisted_5 = { class: "col-sm-12 col-md-8" }
const _hoisted_6 = { class: "col-sm-12 col-md-4" }
const _hoisted_7 = {
  key: 0,
  class: "mx-3 text-center"
}
const _hoisted_8 = { class: "row mb-3" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 0,
  class: "row"
}
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "mb-0 text-muted small" }
const _hoisted_16 = { class: "mb-0 text-muted small" }
const _hoisted_17 = { class: "mb-0 text-muted small" }
const _hoisted_18 = {
  key: 0,
  class: "mb-0 text-muted small"
}
const _hoisted_19 = {
  key: 1,
  class: "mb-0 text-muted small"
}
const _hoisted_20 = { class: "row mb-3" }
const _hoisted_21 = { class: "col-12" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-12" }
const _hoisted_24 = { class: "row mt-4" }
const _hoisted_25 = { class: "col-12" }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-12" }
const _hoisted_29 = { class: "mb-0 text-muted small" }
const _hoisted_30 = { class: "mb-0 text-muted small" }
const _hoisted_31 = { class: "mb-0 text-muted small" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-12" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-12" }
const _hoisted_37 = {
  key: 0,
  class: "row mt-5"
}
const _hoisted_38 = { class: "col-12" }
const _hoisted_39 = { class: "alert alert-danger" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-12" }
const _hoisted_42 = { key: 3 }
const _hoisted_43 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_44 = { key: 1 }
const _hoisted_45 = ["href"]
const _hoisted_46 = ["href"]
const _hoisted_47 = { class: "my-4 float-end" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_scenario_card = _resolveComponent("scenario-card")!
  const _component_visit_schedule_form = _resolveComponent("visit-schedule-form")!
  const _component_terms = _resolveComponent("terms")!
  const _component_StripeElement = _resolveComponent("StripeElement")!
  const _component_StripeElements = _resolveComponent("StripeElements")!
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading && typeof(_ctx.scenario) !== 'undefined')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_scenario_card, {
                    scenario: _ctx.scenario.data,
                    formatted_field_data: _ctx.formatted_field_data
                  }, null, 8, ["scenario", "formatted_field_data"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _cache[31] || (_cache[31] = _createElementVNode("div", { class: "row" }, [
                    _createElementVNode("div", { class: "col-12" }, [
                      _createElementVNode("h2", { class: "text-center" }, "How To Schedule")
                    ])
                  ], -1)),
                  (!_ctx.show_schedule && !_ctx.show_playlist && !_ctx.show_sms_enable)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("button", {
                              class: "btn btn-secondary btn-lg w-100",
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showSchedule && _ctx.showSchedule(...args)))
                            }, [
                              (_ctx.show_payment)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Change Dates"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_11, "Schedule Your Visit"))
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.show_schedule)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "row" }, [
                          _createElementVNode("div", { class: "col-12" }, [
                            _createElementVNode("h4", { class: "text-center" }, [
                              _createTextVNode("Select convenient "),
                              _createElementVNode("u", null, "times"),
                              _createElementVNode("br"),
                              _createTextVNode("for your SP visit")
                            ])
                          ])
                        ], -1)),
                        _createVNode(_component_visit_schedule_form, {
                          field: "visit_date_one",
                          "alt-field": "visit_date_two",
                          "start-date": _ctx.start_date,
                          "end-date": _ctx.end_date,
                          "disabled-dates": _ctx.partner_disabled_dates,
                          onUpdateDate: _ctx.setDate,
                          "scenario-id": _ctx.scenario_id
                        }, null, 8, ["start-date", "end-date", "disabled-dates", "onUpdateDate", "scenario-id"]),
                        (_ctx.scenario.data.fee > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("p", _hoisted_15, [
                                  _cache[11] || (_cache[11] = _createTextVNode("Price: ")),
                                  _createElementVNode("strong", null, "$" + _toDisplayString(_ctx.scenario.data.fee.toFixed(2)), 1)
                                ]),
                                _createElementVNode("p", _hoisted_16, [
                                  _cache[12] || (_cache[12] = _createTextVNode("Processing Fee: ")),
                                  _createElementVNode("strong", null, "$" + _toDisplayString(_ctx.processing_fee.toFixed(2)), 1)
                                ]),
                                _createElementVNode("p", _hoisted_17, [
                                  _cache[13] || (_cache[13] = _createTextVNode("Total: ")),
                                  _createElementVNode("strong", null, "$" + _toDisplayString(_ctx.total_fee.toFixed(2)), 1)
                                ]),
                                (_ctx.has_credit)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                                      _createElementVNode("strong", null, "Account credit of $" + _toDisplayString(_ctx.payment_credit.amount.toFixed(2)) + " will be applied.", 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_19, _cache[14] || (_cache[14] = [
                                      _createElementVNode("strong", null, "Payment will be collected after date/time selection.", -1)
                                    ]))),
                                _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-muted small" }, [
                                  _createElementVNode("strong", null, "SPs will accept your session request within 24-48 hours. Once your session is accepted, you will not be able to reschedule it. Any cancellation and rescheduling will result in another charge.")
                                ], -1))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            (_ctx.scenario.data.fee > 0 && !_ctx.has_credit)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "btn btn-secondary btn-lg w-100",
                                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scheduleForPayment && _ctx.scheduleForPayment(...args)))
                                }, "Schedule Your Visit"))
                              : (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "btn btn-secondary btn-lg w-100",
                                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.scheduleVisit && _ctx.scheduleVisit(...args)))
                                }, "Schedule Your Visit"))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("label", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.terms_agreement) = $event)),
                                name: "terms_agreement",
                                checked: "checked"
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.terms_agreement]
                              ]),
                              _cache[16] || (_cache[16] = _createTextVNode(" Accept Terms and Conditions"))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            (_ctx.show_terms)
                              ? (_openBlock(), _createBlock(_component_terms, { key: 0 }))
                              : (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "btn btn-link text-primary p-0",
                                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.viewTerms && _ctx.viewTerms(...args)))
                                }, "View Terms and Conditions"))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.show_payment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "row" }, [
                          _createElementVNode("div", { class: "col-12" }, [
                            _createElementVNode("h2", null, "Credit Card Payment")
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("p", _hoisted_29, [
                              _cache[18] || (_cache[18] = _createTextVNode("Price: ")),
                              _createElementVNode("strong", null, "$" + _toDisplayString(_ctx.scenario.data.fee.toFixed(2)), 1)
                            ]),
                            _createElementVNode("p", _hoisted_30, [
                              _cache[19] || (_cache[19] = _createTextVNode("Processing Fee: ")),
                              _createElementVNode("strong", null, "$" + _toDisplayString(_ctx.processing_fee.toFixed(2)), 1)
                            ]),
                            _createElementVNode("p", _hoisted_31, [
                              _cache[20] || (_cache[20] = _createTextVNode("Total: ")),
                              _createElementVNode("strong", null, "$" + _toDisplayString(_ctx.total_fee.toFixed(2)), 1)
                            ]),
                            _cache[21] || (_cache[21] = _createElementVNode("p", { class: "mb-0 text-muted small" }, [
                              _createElementVNode("strong", null, "SPs will accept your session request within 24-48 hours. Once your session is accepted, you will not be able to reschedule it. Any cancellation and rescheduling will result in another charge.")
                            ], -1))
                          ])
                        ]),
                        (_ctx.stripe_loaded)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "row" }, [
                                _createElementVNode("div", { class: "col-12" }, [
                                  _createElementVNode("label", { for: "name_on_card" }, "Name as it appears on card")
                                ])
                              ], -1)),
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "mb-4",
                                    type: "text",
                                    maxlength: "100",
                                    name: "name_on_card",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.name_on_card) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.name_on_card]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("div", _hoisted_36, [
                                  (_ctx.stripe_loaded)
                                    ? (_openBlock(), _createBlock(_component_StripeElements, {
                                        key: 0,
                                        type: "payment",
                                        ref: "elms",
                                        "stripe-key": _ctx.stripe_key,
                                        "instance-options": _ctx.instance_options,
                                        "elements-options": _ctx.elements_options
                                      }, {
                                        default: _withCtx(({ elements, instance }) => [
                                          _createVNode(_component_StripeElement, {
                                            ref: "card",
                                            elements: elements,
                                            options: _ctx.card_options,
                                            instance: instance
                                          }, null, 8, ["elements", "options", "instance"])
                                        ]),
                                        _: 1
                                      }, 8, ["stripe-key", "instance-options", "elements-options"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              (_ctx.has_card_error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                    _createElementVNode("div", _hoisted_38, [
                                      _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.card_error), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("div", _hoisted_41, [
                                  (_ctx.stripe_loaded)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "btn btn-primary mt-5",
                                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.pay && _ctx.pay(...args)))
                                      }, "Submit Payment"))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.show_sms_enable)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _cache[27] || (_cache[27] = _createElementVNode("p", null, "Standardized Patient Visits require SMS notifications and confirmations. Please opt-in to SMS notifications below.", -1)),
                        _cache[28] || (_cache[28] = _createElementVNode("label", null, "Mobile Number", -1)),
                        _createVNode(_component_vue_tel_input, {
                          modelValue: _ctx.mobile_number,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.mobile_number) = $event)),
                          value: _ctx.mobile_number,
                          mode: "international",
                          "preferred-countries": ['US','CA','MX'],
                          onValidate: _ctx.setMobile
                        }, null, 8, ["modelValue", "value", "onValidate"]),
                        (!_ctx.mobile_valid)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_43, "Invalid Number"))
                          : (_openBlock(), _createElementBlock("br", _hoisted_44)),
                        _createElementVNode("label", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.mobile_agreed) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.mobile_agreed]
                          ]),
                          _cache[24] || (_cache[24] = _createTextVNode(" Enable SMS Standardized Patient Visit Confirmations and Reminders"))
                        ]),
                        _createElementVNode("p", null, [
                          _createElementVNode("small", null, [
                            _cache[25] || (_cache[25] = _createTextVNode("You will receive visit confirmation messages and reminders via SMS when signing up for SP-ED. Message and data rates may apply. Message Frequency Varies. Reply HELP for help. Reply STOP to opt out. ")),
                            _createElementVNode("a", {
                              href: _ctx.privacy_link,
                              target: "_blank"
                            }, "Privacy Policy", 8, _hoisted_45),
                            _cache[26] || (_cache[26] = _createTextVNode(" | ")),
                            _createElementVNode("a", {
                              href: _ctx.sms_tos_link,
                              target: "_blank"
                            }, "SMS Terms of Service", 8, _hoisted_46)
                          ])
                        ]),
                        _cache[29] || (_cache[29] = _createElementVNode("p", null, [
                          _createElementVNode("small", null, "Note: SP Visits require confirmation and opting out of SMS communications may hinder receipt of confirmation messages")
                        ], -1)),
                        _cache[30] || (_cache[30] = _createElementVNode("p", null, [
                          _createElementVNode("small", null, "A valid mobile number will be required when checking this option. You will receive a verification code upon submission of this form.")
                        ], -1)),
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("button", {
                            class: "btn btn-primary me-4",
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.cancelSmsOptIn && _ctx.cancelSmsOptIn(...args)))
                          }, "Cancel"),
                          _createElementVNode("button", {
                            disabled: !_ctx.mobile_valid || !_ctx.mobile_agreed,
                            class: "btn btn-primary",
                            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.submitSmsOptIn && _ctx.submitSmsOptIn(...args)))
                          }, "Opt-in to SMS", 8, _hoisted_48)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]))
      : (!_ctx.loading && typeof(_ctx.scenario) === 'undefined')
        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
            _cache[32] || (_cache[32] = _createElementVNode("h4", null, "Error Loading Scenario", -1)),
            _createElementVNode("p", null, _toDisplayString(_ctx.loading_error), 1)
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_Loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"]),
    _createVNode(_component_loading, {
      active: _ctx.card_loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}